<template>
	<div class="btn_type_list">
		<button type="button" class="btn_item btn_prev" @click="goToPrevPage">
			<span class="ico_cafenew">이전 보기</span>
		</button>
		<button type="button" class="btn_item btn_next" @click="goToNextPage">
			<span class="ico_cafenew">다음 보기</span>
		</button>
	</div>
</template>

<script>
import mixin from '../common/pagination-mixin';

export default {
	mixins: [mixin],
}
</script>
